import { gql } from 'graphql-tag'
import { consumerFields } from '../consumerFields'

export const AGREE_TO_TERMS_AND_CONDITIONS = gql`
  mutation agreeToTermsAndConditions {
    consumer: agreeToTermsAndConditions {
      ...ConsumerFields
    }
  }
  ${consumerFields}
`
